<template>
  <hooper id="carousel-hooper"  style="height: 400px" :itemsToShow="1" :wheelControl="false" :infiniteScroll="true">
    <slide v-for="(img, index) in propImages" v-bind:key="index">
      <img
        :src="img.img"
        alt
      />
    </slide>
    <hooper-navigation slot="hooper-addons"></hooper-navigation>
  </hooper>
</template>

<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  name: 'ImageCarousel',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    propImages: Array
  }
}
</script>
<style scoped>
#carousel-hooper img {
  width: 100%;
  height: 100%;
}

#carousel-hooper >>> .hooper-next,
#carousel-hooper >>> .hooper-prev {
  padding: 0;
}

#carousel-hooper >>> .hooper-next:focus,
#carousel-hooper >>> .hooper-prev:focus {
  outline: none;
}

#carousel-hooper >>> .hooper-next {
  height: 45px;
  width: 25px;
  border-radius: 90px 0 0 90px;
  background: rgba(0, 0, 0, 0.55);
}

#carousel-hooper >>> .hooper-prev {
  height: 45px;
  width: 25px;
  border-radius: 0 90px 90px 0;
  background: rgba(0, 0, 0, 0.55);
}

#carousel-hooper >>> .icon-arrowRight {
  fill: white;
}

#carousel-hooper >>> .icon-arrowLeft {
  fill: white;
}
</style>
